import React from "react";
import ConnectedCreateTeamFooter from "./ConnectedCreateTeamFooter";
import ConnectedJoinTeamFooter from "./ConnectedJoinTeamFooter";
import { CREATE_TEAM, JOIN_TEAM } from "../../constants/views";
import ModalStateContext from "../../ModalStateContext";
import "./TeamModalFooter.scss";

const TeamModalFooter = () => {
    const { activeView } = React.useContext(ModalStateContext);
    return (
        // eslint-disable-next-line tailwindcss/classnames-order
        <footer className="grid grid--align-items-center team-modal-footer">
            {activeView === JOIN_TEAM && <ConnectedJoinTeamFooter />}
            {activeView === CREATE_TEAM && <ConnectedCreateTeamFooter />}
        </footer>
    );
};

export default TeamModalFooter;
